import { useEffect, useState } from 'react';
// import PropTypes from 'prop-types';

import './CardInfoPanel.css';

import { useAuth } from '../../../hook/useAuth';
import { useCard } from '../../../hook/useCard';
import { useSample } from '../../../hook/useSample';
import CardInfo from '../../../components/CardInfo/CardInfo';
import SimpleButton from '../../../components/SimpleComponents/SimpleButton';
import { sortType } from '../../../components/SamplesList/SampleListContent';
import SamplesList, { viewModeList } from '../../../components/SamplesList/SamplesList';
import Spinner from '../../../components/SimpleComponents/Spinner';
import WorkspacePanel, { WorkspacePanelHead } from '../../../components/WorkspacePanel/WorkspacePanel';

const CardPanel = () => {
	const { authenticated } = useAuth();
	const { activeCard, setActiveCard } = useCard();
	const { samples, getSamplesForCard } = useSample();

	const [loadingSamples, setLoadingSamples] = useState(false);

	useEffect(() => {
		if (authenticated && activeCard) {
			setLoadingSamples(true);
			getSamplesForCard(activeCard.id, (_samples) => {
				setLoadingSamples(false);
			});
		} else {
			setLoadingSamples(false);
		}
		// getSamplesForCard is stable from provider
	}, [authenticated, activeCard]); // eslint-disable-line react-hooks/exhaustive-deps

	return activeCard ? (
		<WorkspacePanel className="card-info-panel">
			<WorkspacePanelHead title={activeCard.name}>
				<SimpleButton title="Close panel" value="Close" onClick={handleClose} />
			</WorkspacePanelHead>
			<CardInfo card={activeCard} />
			{authenticated && loadingSamples ? (
				<div className="samples-spinner">
					<Spinner />
				</div>
			) : null}
			{authenticated && !loadingSamples && Object.keys(samples).length > 0 ? (
				<div className="card-presence">
					<div className="subhead">This card in your collection:</div>
					<SamplesList
						active_sample={null}
						default_sort={sortType.storage}
						isOwned={true}
						samples={samples}
						show_subhead={false}
						updated_sample={null}
						viewMode={viewModeList.rows}
						onActivate={handleActivateSample}
					/>
				</div>
			) : null}
		</WorkspacePanel>
	) : null;

	function handleClose() {
		setActiveCard(null);
	}

	function handleActivateSample(sample) {
		console.log('Activate sample from CardInfoPanel:', sample);
	}
};

CardPanel.propTypes = {};

export default CardPanel;
